export const LOADING = 'loading';
export const SET_LOADING = 'setLoading';
